import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Content from '../components/Content/Content';
import { NextSeo } from 'next-seo';
import {getData} from "../utils/functions";

export default function App() {
    const router = useRouter();
    const [redirectUrl, setRedirectUrl] = useState('');
    const [showSpinner, setShowSpinner] = useState(true);

    useEffect(() => {
        // Check if the user is directly visiting the downloads page
        if (router.asPath === '/downloads') {
            setShowSpinner(true);
            setTimeout(() => {
                setRedirectUrl('https://nomo.app/install');
            }, 2000);
        } else {
            const { comingFromWebOnInstallation } = router.query;
            if (comingFromWebOnInstallation) {
                const sourceUrl = new URL(comingFromWebOnInstallation);
                const domainName = sourceUrl.pathname.split('/webon/')[1];
                const params = new URLSearchParams(sourceUrl.search);

                setShowSpinner(true);
                fetch(`https://webon.info/api/webons/en`)
                    .then(response => response.json())
                    .then(async data => {
                        let webon = data.find(w => w.domain === domainName);
                        if (!webon) {
                            webon = await getData('webon/' + domainName);
                        }
                        if (webon) {
                            params.set('id', webon.id);
                            params.set('comingFromWebOnInstallation', encodeURIComponent(comingFromWebOnInstallation));
                            const finalRedirectUrl = `https://discover.webon.info/webon?${params.toString()}`;
                            setRedirectUrl(finalRedirectUrl);
                        } else {
                            setRedirectUrl("/install");
                        }
                    })
                    .catch(error => {
                        console.error('Failed to fetch webon:', error);
                        setShowSpinner(false);
                    });
            }
        }
    }, [router.query, router.asPath]);

    useEffect(() => {
        if (redirectUrl) {
            setTimeout(() => {
                window.location.href = redirectUrl;
            }, 3000);
        }
    }, [redirectUrl]);
    return (
        <>
            <NextSeo
                title="Nomo"
                description="Download the newest version of Nomo"
            />
            <Content theme={'dark'} transparent={true}>
                {showSpinner ? (
                    <div className="section">
                        <div className="spinner"></div>
                        <p>Fetching data...</p>
                    </div>
                ) : (
                    <div className="section">
                        <p>Not available or does not meet the requirements.</p>
                    </div>
                )}
            </Content>
            <style jsx>{`
                .spinner {
                    border: 4px solid rgba(0, 0, 0, 0.1);
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    border-left-color: #cdaf6d;
                    animation: spin 1s ease infinite;
                }

                @keyframes spin {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }

                .section {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    min-height: 100vh;
                    background: linear-gradient(135deg, #f8f8f8, #e0e0e0);
                }
            `}</style>
        </>
    );
}